const clearEventAsset = function ({ commit }) {
  commit("CLEAR_EVENT_ASSET");
};

export default clearEventAsset;
